import React, { Suspense } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { IconClose, IconSearch } from "../../icons/svg/index.js";
import ContactList from '../contact-list.jsx';
import SearchContacts from '../search-contacts.jsx';
import { Tinode } from '../../tinode/tinode.js'

const messages = defineMessages({
	share_link_button: {
		id: "share_link_button",
		defaultMessage: "Share the link",
		description: "Share the link",
	},
	content_share_group_link_invite: {
		id: "content_share_group_link_invite",
		defaultMessage: "You're invited to join the \"{groupName}\" group at: {url}",
		description: "You're invited to join the \"{groupName}\" group at: {url}",
	}
})

class ShareGroupInviteLink extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			query: null,
		}

		this.handleSearchContacts = this.handleSearchContacts.bind(this)
		this.handleContactSelected = this.handleContactSelected.bind(this)
		this.handleTopicSelected = this.handleTopicSelected.bind(this);
	}

	componentDidMount() {

	}

	handleSearchContacts(query) {
		if (this.searchEvent != null) {
			clearTimeout(this.searchEvent)
		}
		this.searchEvent = setTimeout(() => {
			this.setState({ query: Tinode.isNullValue(query) ? null : query });
			this.props.onSearchContacts(query, 2);
		}, 200)
	}

	handleContactSelected(uid) {
		const { formatMessage } = this.props.intl;
		const topic = this.props.tinode.getTopicByName(uid)
		const content = formatMessage(messages.content_share_group_link_invite, { url: this.props.inviteUrl, groupName: this.props.groupName })
		this.props.sendMessageToTopic(topic, content, null, null, {})
	}

	handleTopicSelected(topicName) {
		this.props.onTopicSelected(topicName);
		this.props.onClose()
	}

	render() {
		const { formatMessage } = this.props.intl;

		let contacts = this.state.query != null ? this.props.searchResults : this.props.contacts;
		// Filter out contacts without a 'W' or 'J' permissions as well as the current topic.
		if (this.state.query === null) {
			contacts = contacts.filter((c) => {
				return c.acs.isJoiner() && c.acs.isWriter();
			}).sort((u1, u2) => u1.touched - u2.touched < 0 ? 1 : -1);
		}

		return (
			<Suspense
				fallback={
					<div className="panel-form-row">
						<FormattedMessage
							id="loading_note"
							defaultMessage="Loading..."
							description="Message shown when component is loading"
						/>
					</div>
				}>
				<div className="dialog-share-group-invite-link">
					<div className="header">
						<div className="title">
							{formatMessage(messages.share_link_button)}
						</div>
						<div className="icon" onClick={this.props.onClose}>
							<IconClose />
						</div>
					</div>
					<div className="content">
						<SearchContacts
							placeholder={''}
							onSearchContacts={this.handleSearchContacts}
							tinode={this.props.tinode}
						/>

						<div className="contact-list">
							<ContactList
								tinode={this.props.tinode}
								contacts={contacts}
								myUserId={this.props.myUserId}
								emptyListMessage={''}
								showOnline={false}
								showUnread={false}
								showContextMenu={false}
								onTopicSelected={this.handleContactSelected}
								handleTopicSelected={this.handleTopicSelected}
								showButtonForward={true}
							/>
						</div>
					</div>
				</div>
			</Suspense>
		)
	}
}

export default injectIntl(ShareGroupInviteLink);